module.exports = __webpack_public_path__ + "static/media/image14.942da71b.png";